





































import { Vue, Component, Prop, Model, Watch, Emit } from 'vue-property-decorator';
import { ValidationProvider as validationProvider } from 'vee-validate';
import downIcon from '@/assets/icons/down.svg';

@Component({
  name: 'ValidationTextField',
  components: {
    validationProvider,
  }
})
/**
 * @vuese
 * @group Atomic/Organisms
 * validation textfield
 */
export default class ValidationTextField extends Vue {
  // [Model]
  @Model('input', { type: String }) value!: string;

  // [Prop]
  @Prop({ type: Boolean, default: false}) isMultiline!: boolean;
  @Prop({ type: String, default: 'text' }) type!: string;
  @Prop() message!: string|Object;
  @Prop({ type: String, default: '' }) placeholder!: string;
  @Prop({ type: String, default: '' }) rules!: string;

  // [Watch]
  @Watch('value')
  input() {
    this.inputValue = this.value;
  }

  // [Data]
  inputValue: string = ''
  isErrorDisplay: boolean = false;

  // [Methods]
  valueChanged(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      this.$emit('input', e.target.value);
    }
  }

  changeValue(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      this.$emit('change', e.target.value);
  }
  }

  displayError() {
    this.isErrorDisplay = true;
  }

  hideError() {
    this.isErrorDisplay = false;
  }

  getMessage(errorName: string) {
    if (typeof(this.message) === "string") {
      return this.message;
    }
    if (typeof(this.message) === "object" && this.message.hasOwnProperty(errorName)) {
      return (this.message as any)[errorName];
    }
    return errorName;
  }

  // [Life cycle]
  created() {
  }
}
